import { LimitUpsellModalProps } from './LimitUpsellModalProps'
import { UpsellModal } from '../UpsellModal/UpsellModal'
import React, { forwardRef } from 'react'

/**
 * This is an abstraction for functionality common to all limit upsell experiences.
 * For instance, this may be expanded in the future to take arguments like what
 * the user's current limit is and how many more they need or what action they tried to
 * perform in order to better dictate how the upsell experience should be.
 *
 * It should NOT be used on its own, but should be used by specific limit upsells.
 *
 * @see UpsellModal
 * @see FlowcodeLimitUpsellModal
 */
export const LimitUpsellModal = forwardRef<HTMLDivElement, LimitUpsellModalProps>(
  function LimitUpsellModal(props, ref): JSX.Element {
    return <UpsellModal {...props} ref={ref} />
  }
)
